// extracted by mini-css-extract-plugin
export default {"wrapper":"pg-marketplace-estimates-details-block-module__wrapper--wPB"};